import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Filler element, used to create some visual space between elements
 *
 * @prop {String} size - used to define the height of the filler
 *
 */
let SDBLayoutFiller = class SDBLayoutFiller extends LitElement {
    constructor() {
        super(...arguments);
        this.size = '';
    }
    render() {
        return html ` <div style="height:${this.size}px;"></div> `;
    }
};
SDBLayoutFiller.styles = [
    elements,
    css `
            :host div {
                display: block;
                width: 100%;
                height: 1px;
                opacity: 0;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBLayoutFiller.prototype, "size", void 0);
SDBLayoutFiller = __decorate([
    customElement('sdb-layout-filler')
], SDBLayoutFiller);
export { SDBLayoutFiller };
//# sourceMappingURL=sdb-layout-filler.js.map